// extracted by css-extract-rspack-plugin
export default {"imageWrapper":"_3e355497","small":"_1a63b0fc","medium":"_ca7f8cde","large":"_15db715e"};